import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import InvesCarriers from './pages/InvesCarriers';
import btdetails from './pages/BtDetails';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" Component={Index}></Route>
          <Route path="/invesCarriers" Component={InvesCarriers}></Route>
          <Route path="/btdetails" Component={btdetails}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
